import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-type-donor-document.reducer';
import { IConsTypeDonorDocument } from 'app/shared/model/cons-type-donor-document.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsTypeDonorDocument = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consTypeDonorDocumentList = useAppSelector(state => state.consTypeDonorDocument.entities);
  const loading = useAppSelector(state => state.consTypeDonorDocument.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-type-donor-document-heading" data-cy="ConsTypeDonorDocumentHeading">
        <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.home.title">Cons Type Donor Documents</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.home.createLabel">
              Create new Cons Type Donor Document
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consTypeDonorDocumentList && consTypeDonorDocumentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consTypeDonorDocumentList.map((consTypeDonorDocument, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consTypeDonorDocument.id}`} color="link" size="sm">
                      {consTypeDonorDocument.id}
                    </Button>
                  </td>
                  <td>{consTypeDonorDocument.code}</td>
                  <td>{consTypeDonorDocument.name}</td>
                  <td>{consTypeDonorDocument.nameAr}</td>
                  <td>{consTypeDonorDocument.nameEn}</td>
                  <td>{consTypeDonorDocument.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consTypeDonorDocument.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonorDocument.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonorDocument.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consTypeDonorDocument.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consTypeDonorDocument.home.notFound">
                No Cons Type Donor Documents found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsTypeDonorDocument;
